const knownManagementCompanyCodes = new Set<string>(['a', 'b', 'c'] satisfies Array<'a' | 'b' | 'c'>);

function isKnownManagementCompanyCode(selection: string): selection is 'a' | 'b' | 'c' {
  return knownManagementCompanyCodes.has(selection);
}

export function isFilledManagementCompanySelection(selection: string | undefined): boolean {
  const name = selection?.trim() ?? '';
  return name.length > 0 && name !== 'd';
}

export function managementCompaniesSelectionChanged(
  previous: readonly string[] | undefined,
  current: readonly string[],
): boolean {
  const previousSelection = previous ?? [];
  if (previousSelection.length !== current.length) {
    return true;
  }
  return previousSelection.some((selection, index) => selection !== current[index]);
}

export function formatManagementCompanyNames(
  selections: readonly string[],
  companyLabel: (code: 'a' | 'b' | 'c') => string,
): string {
  return selections
    .map((selection) => {
      if (isKnownManagementCompanyCode(selection)) {
        return companyLabel(selection);
      }
      if (!isFilledManagementCompanySelection(selection)) {
        return '';
      }
      return selection.trim();
    })
    .filter((name) => name.length > 0)
    .join(', ');
}
